import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Mail, CheckCircle, AlertCircle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NewsletterSection = () => {
  const [config, setConfig] = useState({
    enabled: false,
    title: 'Stay Updated with Visaasure',
    description: 'Subscribe to our newsletter for the latest visa updates, immigration tips, and exclusive offers.',
    button_text: 'Subscribe',
    placeholder: 'Enter your email address',
    success_message: 'Thank you for subscribing!'
  });
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const response = await axios.get(`${API}/settings/newsletter_config`);
      setConfig(response.data.setting_value);
    } catch (error) {
      console.error('Failed to fetch newsletter config:', error);
    }
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setMessage({ type: 'error', text: 'Please enter a valid email address' });
      return;
    }

    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await axios.post(`${API}/newsletter/subscribe`, { email });
      setMessage({ type: 'success', text: response.data.message || config.success_message });
      setEmail('');
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.detail || 'Failed to subscribe. Please try again.' 
      });
    } finally {
      setLoading(false);
    }
  };

  if (!config.enabled) return null;

  return (
    <div className="newsletter-section">
      <div className="container">
        <div className="newsletter-content">
          <div className="newsletter-header">
            <Mail size={32} className="newsletter-icon" />
            <div className="newsletter-text">
              <h3 className="newsletter-title">{config.title}</h3>
              <p className="newsletter-description">{config.description}</p>
            </div>
          </div>

          <form onSubmit={handleSubscribe} className="newsletter-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={config.placeholder}
              className="newsletter-input"
              disabled={loading}
            />
            <button 
              type="submit" 
              className="newsletter-button"
              disabled={loading}
            >
              {loading ? 'Subscribing...' : config.button_text}
            </button>
          </form>

          {message.text && (
            <div className={`newsletter-message ${message.type}`}>
              {message.type === 'success' ? (
                <CheckCircle size={16} />
              ) : (
                <AlertCircle size={16} />
              )}
            <span>{message.text}</span>
          </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default NewsletterSection;
